<script setup>
import { computed } from 'vue'

const props = defineProps({
  rank: Number,
  score: Number,
  rankMax: Number,
  textColor: String
})

const progressPercentage = computed(() => {
  if (!!props.rankMax) {
    return (props.score / props.rankMax) * 100
  }
  return 0
})
</script>

<template>
  <div class="flex relative gap-1 items-start py-0.5 mt-1 w-full">
    <div
      class="flex z-0 flex-1 shrink self-stretch my-auto h-1 basis-0 bg-[#ffffff1a] min-w-[240px]"
    />

    <div
      class="flex absolute left-0 bottom-0 w-[3px] shrink-0 h-[8px] bg-white border border-zinc-800 shadow-xs"
      :style="{ left: progressPercentage + '%' }"
    />

    <div
      class="flex absolute left-0 bottom-px z-0 shrink-0 h-1.5"
      :style="{ width: progressPercentage + '%', backgroundColor: textColor }"
    />
  </div>
</template>
